export default "__VITE_ASSET__CrzViJkG__"